<template>
  <q-btn
    :label="label"
    round
    title="Manage clients"
    @click="openModal">
    <q-icon v-if="!hasSubscriptions" name="fa fa-plus"/>
  </q-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import { DetailedUser } from '@/type';
import UserClientsModal from './UserClientsModal.vue';

export default defineComponent({
  props: {
    user: {
      type: Object as () => DetailedUser,
      required: true,
    },
  },
  computed: {
    hasSubscriptions(): boolean {
      return (this.user.totalSubscriptions > 0);
    },
    label(): string {
      return this.hasSubscriptions ? `${this.user.totalSubscriptions}` : '';
    },
  },
  methods: {
    openModal() {
      openModal(UserClientsModal, {
        parent: this,
        user: this.user,
      });
    },
  },
});
</script>
